"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabsContext = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _Tabs = require("../../components/Tabs/Tabs.styles");
var _Theme = require("../../themes/Theme");
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _splitCommonFromProps6 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _excluded = ["className", "children", "expand", "onChange", "overrides", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */ /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
/**
 * The directly overridable styles for `Tabs`
 */

/**
 * The custom props for `Tabs`
 */

var TabsContext = exports.TabsContext = /*#__PURE__*/(0, _react.createContext)(true);
var useExpandProps = function useExpandProps(childrenLength, value) {
  var theme = (0, _reactJss.useTheme)();
  var tabsExpandTransform = "translate(".concat(theme.direction === _Theme.Direction.rtl ? "-" : "").concat(100 / childrenLength * (value * childrenLength), "%, 0)");
  var tabsExpandWidth = "".concat(100 / childrenLength, "%");
  return {
    tabsExpandTransform: tabsExpandTransform,
    tabsExpandWidth: tabsExpandWidth
  };
};
var Tabs = function Tabs(props) {
  var _splitCommonFromProps = (0, _splitCommonFromProps6.default)(props, _Tabs.tabsCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    className = _splitCommonFromProps3.className,
    children = _splitCommonFromProps3.children,
    _splitCommonFromProps4 = _splitCommonFromProps3.expand,
    expand = _splitCommonFromProps4 === void 0 ? true : _splitCommonFromProps4,
    onChange = _splitCommonFromProps3.onChange,
    _splitCommonFromProps5 = _splitCommonFromProps3.overrides,
    overrides = _splitCommonFromProps5 === void 0 ? {} : _splitCommonFromProps5,
    value = _splitCommonFromProps3.value,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded);
  var _useState = (0, _react.useState)(value !== null && value !== void 0 ? value : 0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var _useExpandProps = useExpandProps(children.length, selectedIndex),
    tabsExpandTransform = _useExpandProps.tabsExpandTransform,
    tabsExpandWidth = _useExpandProps.tabsExpandWidth;
  (0, _react.useEffect)(function () {
    if (value !== undefined) {
      setSelectedIndex(value);
    }
  }, [value]);
  var classes = (0, _Tabs.useTabsStyles)(_objectSpread({
    tabsExpandTransform: tabsExpandTransform,
    tabsExpandWidth: tabsExpandWidth
  }, common));
  var rootRef = /*#__PURE__*/(0, _react.createRef)();
  var onChangeHandler = function onChangeHandler(event) {
    // Don't respond to click events when the user clicks the parent
    // (somehow clicks between the children) or when they click the indicator line
    if (event.target === rootRef.current || event.target === rootRef.current.lastChild) {
      return;
    }
    var targetIndex = Array.from(rootRef.current.childNodes).findIndex(function (elem) {
      return elem === event.target;
    });
    if (value === undefined) {
      setSelectedIndex(targetIndex);
    }

    // Don't anything if we get an invalid targetIndex.
    // Subtract 2 (instead of 1) to account for indicator line
    if (targetIndex < 0 || targetIndex > rootRef.current.childNodes.length - 2) {
      return;
    }
    if (!onChange) {
      return;
    }
    onChange(targetIndex);
  };
  return /*#__PURE__*/_react.default.createElement(TabsContext.Provider, {
    value: expand
  }, /*#__PURE__*/_react.default.createElement("nav", _extends({
    ref: rootRef,
    onClick: onChangeHandler,
    className: (0, _classnames.default)(classes.variables, classes.root, overrides.root, className)
  }, otherProps), children, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_defineProperty({}, classes.indicator, expand), overrides.indicator)
  })));
};
Tabs.displayName = "Tabs";
var Storybook = exports.Storybook = Tabs;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/navigation-tabs--docs
 */
var exportedComponent = (0, _defaultProps.default)(Tabs);
exportedComponent.displayName = "Tabs";
var _default = exports.default = exportedComponent;